module.exports = "pegasus/assets/themelp1/product/101.png";